export default __webpack_public_path__ + "static/media/new-14.5e7369e0.png";